module.exports = __webpack_public_path__ + "img/461.5cce0d7c.jpg";